import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src879763043/src/codemochi-courses/src/components/routes/public/Lecture.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ZipViewer = makeShortcode("ZipViewer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className="objective">
  <p>
    <span>Objective:</span> Add the queries and mutations that we will use in
    the rest of the app.
  </p>
    </div>
    <ZipViewer zipName={'frontend-serverless-graphql'} header="Click to download the graphQL files" mdxType="ZipViewer" />
    <p>{`This step is easy- just copy the following queries and mutations into the `}<inlineCode parentName="p">{`graphql/queries`}</inlineCode>{` and `}<inlineCode parentName="p">{`graphql/mutations`}</inlineCode>{` folders. Also make sure to install `}<inlineCode parentName="p">{`graphql-tag`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install --save graphql-tag
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-graphql/mutations/createRecipe.ts"
      }}>{`import gql from 'graphql-tag';

export const createRecipeGraphQL = gql\`
  mutation createRecipeGraphQL($data: RecipeCreateInput!) {
    createRecipe(data: $data) {
      id
      title
      content
      description
      ingredients
      userLikes {
        id
      }
      owner
      image {
        id
        fileName
        height
        width
        size
        handle
      }
    }
  }
\`;

`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-graphql/mutations/createUserLike.ts"
      }}>{`import gql from 'graphql-tag';

export const createUserLikeGraphQL = gql\`
  mutation createUserLikeGraphQL($data: UserLikeCreateInput!) {
    createUserLike(data: $data) {
      id
      user
      recipe {
        id
      }
    }
  }
\`;

`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-graphql/mutations/deleteAsset.ts"
      }}>{`import gql from 'graphql-tag';

export const deleteAssetGraphQL = gql\`
  mutation deleteAssetGraphQL($where: AssetWhereUniqueInput!) {
    deleteAsset(where: $where) {
      id
    }
  }
\`;

`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-graphql/mutations/deleteRecipe.ts"
      }}>{`import gql from 'graphql-tag';

export const deleteRecipeGraphQL = gql\`
  mutation deleteRecipeGraphQL($where: RecipeWhereUniqueInput!) {
    deleteRecipe(where: $where) {
      id
    }
  }
\`;

`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-graphql/mutations/deleteUserLike.ts"
      }}>{`import gql from 'graphql-tag';

export const deleteUserLikeGraphQL = gql\`
  mutation deleteUserLikeGraphQL($where: UserLikeWhereUniqueInput!) {
    deleteUserLike(where: $where) {
      id
      user
    }
  }
\`;

`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-graphql/mutations/updateRecipe.ts"
      }}>{`import gql from 'graphql-tag';

export const updateRecipeGraphQL = gql\`
  mutation updateRecipeGraphQL(
    $data: RecipeUpdateInput!
    $where: RecipeWhereUniqueInput!
  ) {
    updateRecipe(data: $data, where: $where) {
      id
      title
      content
      description
      ingredients
      userLikes {
        id
      }
      owner
      image {
        id
        fileName
        height
        width
        size
        handle
      }
    }
  }
\`;

`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-graphql/queries/recipe.ts"
      }}>{`import gql from 'graphql-tag';

export const recipeGraphQL = gql\`
  query recipeGraphQL($where: RecipeWhereUniqueInput!) {
    recipe(where: $where) {
      id
      title
      content
      description
      ingredients
      userLikes {
        id
        user
      }
      owner
      image {
        id
        fileName
        height
        width
        size
        handle
      }
    }
  }
\`;

`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-graphql/queries/recipes.ts"
      }}>{`import gql from 'graphql-tag';

export const recipesGraphQL = gql\`
  query recipesGraphQL($where: RecipeWhereInput) {
    recipes(where: $where) {
      id
      title
      content
      description
      ingredients
      userLikes {
        id
        user
      }
      owner
      image {
        id
        fileName
        height
        width
        size
        handle
      }
    }
  }
\`;

`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-graphql/queries/userLike.ts"
      }}>{`import gql from 'graphql-tag';

export const userLikeGraphQL = gql\`
  query userLikeGraphQL($where: UserLikeWhereUniqueInput!) {
    userLike(where: $where) {
      id
      user
      recipe {
        id
        title
        content
        description
        ingredients
        userLikes {
          id
          user
        }
        owner
        image {
          id
          fileName
          height
          width
          size
          handle
        }
      }
    }
  }
\`;

`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-graphql/queries/userLikes.ts"
      }}>{`import gql from 'graphql-tag';

export const userLikesGraphQL = gql\`
  query userLikesGraphQL($where: UserLikeWhereInput) {
    userLikes(where: $where) {
      id
      user
      recipe {
        id
        title
        content
        description
        ingredients
        userLikes {
          id
          user
        }
        owner
        image {
          id
          fileName
          height
          width
          size
          handle
        }
      }
    }
  }
\`;

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      